import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular'

@Injectable()
export class SegmentService {

  constructor(private restangular:Restangular) {
  }

  getAllSegments() {
    return this.restangular.all('getAllSegments');
  }

  getLocationsFormData() {
    return this.restangular.one('getAllEmployeesFormData');
  }

  segmentsCRUD() {
    return this.restangular.all('segmentsCRUD');
  }

  getSegmentByCompany() {
    return this.restangular.one('getSegmentByCompany');
  }

  segmentUD(id) {
    return this.restangular.one('segmentsCRUD/' + id);
  }

  getSegmentBySecondaryCompany() {
    return this.restangular.one('getSegmentBySecondaryCompany');
  }

  getSegmentBaseSecondaryCompany() {
    return this.restangular.all('getSegmentBaseSecondaryCompany');
  }

  getAllServiceLines() {
    return this.restangular.all('getAllServiceLines');
  }

  getServiceLineBySegment() {
    return this.restangular.one('getServiceLineBySegment');
  }

  getServiceLineBySegmentMulti() {
    return this.restangular.all('getServiceLineBySegmentMulti');
  }

  getServiceLines() {
    return this.restangular.one('getServiceLines');
  }

  getServiceLineBySecondaryCompany() {
    return this.restangular.one('getServiceLines');
  }




}



// WEBPACK FOOTER //
// /app/src/app/services/segment.service.ts